import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface DeleteConfirmCSSStyle extends UIComponentCSSStyle
{
    getHeaderDivCSSStyle():object;
    getTitleCSSStyle():object;
    getMobileTitleCSSStyle():object;
    getCloseIconDivCSSStyle():object;
    getMobileCloseIconDivCSSStyle():object;
    getCloseIconCSSStyle():object;
}

export class DeleteConfirmCSSStyleImpl extends UIComponentCSSStyleImpl implements DeleteConfirmCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "308px",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            flexFlow: "row wrap",
            
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            width: "87%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft: "60px",
            // paddingRight:"60px",
            textAlign:'center',
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "10%",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer",
        };
    }


    getMobileTitleCSSStyle(): object {
        return {
            
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            // paddingLeft: "40px",
            // paddingRight:"60px",
            textAlign:'center',
            fontSize: "18px",
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
        };
    }
    
    getMobileCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }
}    
   


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/deleteconfirmation/deleteconfirmationcss.tsx